import React, { useState } from "react";
import HPageContainer from "../../../hcomponents/HPageContainer";
import HHeader from "../../../hcomponents/HHeader";
import HToggle from "src/hcomponents/HToggle";
import SettingsTabsNavigation from "./SettingsTabsNavigation";
import HPillTabs from "src/hcomponents/HPillTabs";
import { CalendarClock, CreditCard, User2, TriangleAlert } from "lucide-react";

const notificationSettings = [
  {
    title: "Booking Notifications",
    items: [
      {
        title: "New Booking",
        desc: "When a new booking is made",
        enabled: true,
        icon: <CalendarClock className="text-indigo-600" />,
      },
      {
        title: "Booking Cancellation",
        desc: "When a booking is cancelled",
        enabled: true,
        icon: <CalendarClock className="text-indigo-600" />,
      },
      {
        title: "Booking Modification",
        desc: "When a booking is modified",
        enabled: false,
        icon: <CalendarClock className="text-indigo-600" />,
      },
    ],
  },
  {
    title: "Payment Notifications",
    items: [
      {
        title: "Payment Received",
        desc: "When a payment is successfully processed",
        enabled: true,
        icon: <CreditCard className="text-indigo-600" />,
      },
      {
        title: "Payment Failed",
        desc: "When a payment attempt fails",
        enabled: true,
        icon: <CreditCard className="text-indigo-600" />,
      },
    ],
  },
  {
    title: "Member Notifications",
    items: [
      {
        title: "New Member",
        desc: "When a new member joins",
        enabled: true,
        icon: <User2 className="text-indigo-600" />,
      },
      {
        title: "Member Cancelled",
        desc: "When a member cancels their account",
        enabled: true,
        icon: <User2 className="text-indigo-600" />,
      },
    ],
  },
  {
    title: "System Notifications",
    items: [
      {
        title: "Low Inventory",
        desc: "When inventory items are running low",
        enabled: false,
        icon: <TriangleAlert className="text-indigo-600" />,
      },
      {
        title: "System Alerts",
        desc: "Critical system notifications",
        enabled: true,
        icon: <TriangleAlert className="text-indigo-600" />,
      },
      {
        title: "Marketing Updates",
        desc: "New features and promotional information",
        enabled: false,
        icon: <TriangleAlert className="text-indigo-600" />,
      },
    ],
  },
];

const SettingsNotification = () => {
  const [tab, setTab] = useState("Email Notifications");
  const notificationTabs = ["Email Notifications", "SMS Notifications"];

  return (
    <HPageContainer>
      <HHeader />
      <div className="overflow-auto">
        <SettingsTabsNavigation />

        {/* Notification Settings */}
        <h2 className="text-xl font-semibold mx-3 text-gray-800 mb-4">Notification Settings</h2>

        <HPillTabs tabs={notificationTabs} activeTab={tab} onTabChange={setTab} className="mb-6" />

        <div className="space-y-10 mx-3 mb-4 padding bg-white rounded-2xl">
          {notificationSettings.map(section => (
            <div key={section.title} className="">
              <div className="border-b border-gray-200 mx-4 pt-3 font-medium text-lg text-gray-900">
                {section.title}
              </div>
              <ul className="divide-y divide-gray-200">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-center justify-between mx-4 pt-3 pb-2">
                    <div className="flex items-center gap-2 ">
                      <div className="pt-1">{item.icon}</div>
                      <div>
                        <div className="font-medium text-gray-900">{item.title}</div>
                        <div className="text-sm text-gray-500 sm:text-xs">{item.desc}</div>
                      </div>
                    </div>
                    <HToggle className="sm:mx-4" />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </HPageContainer>
  );
};

export default SettingsNotification;
